import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAlertDialogStore } from "../store/useAlertDialogStore";

const AppAlertDialog = () => {
  const { open, title, message, closeAlert } = useAlertDialogStore();

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      disableEscapeKeyDown
      aria-labelledby="app-alert-title"
      aria-describedby="app-alert-message"
    >
      <DialogTitle id="app-alert-title" sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={closeAlert}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography id="app-alert-message" variant="body2" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          onClick={closeAlert}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppAlertDialog;
